import React from "react";
import { Sparkles, ShieldCheck } from "lucide-react";
import HubSpotForm from "./HubSpotForm";

/**
 * HostApplicationForm — preserved as a named component for the existing
 * route imports, but the inputs now route through the unified HubSpot embed.
 */
export default function HostApplicationForm({ program = "host_tier", title }) {
  return (
    <div className="lux-card" data-testid="host-app-form">
      <div className="flex items-center gap-2">
        <Sparkles size={18} strokeWidth={1.25} className="text-[var(--gold)]" />
        <div className="overline">Host application</div>
      </div>
      <h3 className="font-display text-4xl text-[var(--emerald)] mt-3">
        {title || "Apply to host with Janté."}
      </h3>
      <p className="text-sm text-[var(--ink-2)] mt-3 max-w-xl">
        Submit the form below — a Janté host-partnerships concierge will reach out within one
        week with next steps.
      </p>
      <div className="mt-6">
        <HubSpotForm context={`host-${program}`} />
      </div>
      <p className="text-[11px] text-[var(--muted)] mt-4 flex items-center gap-1.5">
        <ShieldCheck size={11} strokeWidth={1.25} className="text-[var(--gold)]" />
        Your details are private. A Property's Concierge will contact you within one week to
        review the next steps.
      </p>
    </div>
  );
}
